import React, { useEffect, useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { socket } from "../context/socket";
import Countdown from "react-countdown";
import Moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Bars } from "react-loader-spinner";
import apiService from "../core/service/detail";
import { getMethod, postMethod } from "../core/service/common.api";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
const Payment = () => {
  const initialFormValue = {
    message: "",
    file: "",
    type: "",
    orderId: "",
    chatType:"",
    p2porderId: "",
  };

  const p2pFormValue = {
    qty: "",
    total: "",
  };

  const [siteLoader, setSiteLoader] = useState(true);
  const [p2pData, setp2pData, p2pDataref] = useState("");
  const [orderType, setorderType, orderTyperef] = useState("");
  const [p2pdate, setp2pDate, p2pdateref] = useState("");
  const [profileData, setprofileData, profileDataref] = useState(null);
  const [profileStatus, setprofileStatus, profileStatusref] = useState(false);
  const [formValue, setFormValue, formValueref] = useState(initialFormValue);
  const [p2pfile, setp2pfile, p2pfileref] = useState("");
  const [chatloading, setchatloading] = useState(false);
  const { message, file, type, orderId, p2porderId } = formValue;
  const [p2pchat, setp2pchat, p2pchatref] = useState("");
  const [interval, setintervalchat, intervalref] = useState("");
  const [runningTimer, setRunningTimer] = useState(false);
  const [bankData, setbankData, bankDataref] = useState("");
  const [p2pformValue, setp2pFormValue, p2pformValueref] =
    useState(p2pFormValue);
  const [notifymessage, setnotifymessage, notifymessageref] = useState("");
  const [confirmp2pcheck, setconfirmp2pcheck, confirmp2pcheckref] = useState(
    []
  );
  const { qty, total } = p2pformValue;
  const [p2pbalance, setp2pbalance, p2pbalanceref] = useState("");
  const [disputefile, setdisputefile, disputefileref] = useState("");
  const [disputequery, setdisputequery, disputequeryref] = useState("");
  const [confirmp2porder, setconfirmp2porder, confirmp2porderref] =
    useState("");
  const [p2pbankcheck, setp2pbankcheck, p2pbankcheckref] = useState(false);
  const [p2pbankData, setp2pbankData, p2pbankDataref] = useState("");
  const [Timer, setTimer, Timerref] = useState("");
  const [Timerstatus, setTimerstatus, Timerstatusref] = useState("deactive");

  const [sellTimer, setsellTimer, sellTimerref] = useState("");
  const [sellTimerstatus, setsellTimerstatus, sellTimerstatusref] =
    useState("deactive");
  const [payTime, setpayTime, payTimeref] = useState("15");
  const [p2pRating, setp2pRating, p2pRatingref] = useState(0);
  const [p2pOrdercount, setp2pOrdercount, p2pOrdercountref] = useState(0);
  const [confirmorderloader, setconfirmloader] = useState(false);
  const [loader, setloader] = useState(false);
  const [headurl, setheadurl, headurlref] = useState("");

  const navigate = useNavigate();

  const getp2pChat = async () => {
    setSiteLoader(true);
    var onj = {
      orderId: headurlref.current,
    };
    var data = {
      apiUrl: apiService.getp2pchat,
      payload: onj,
    };
    var resp = await postMethod(data);
    setSiteLoader(false);
    //  setChatData([]);
    if (resp) {
      var data = resp.Message;
      setp2pchat(data);
    }else{
      setp2pchat([])
    }
  };

  const handleChange = async (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const santisedValue = value.replace(/^\s+/, "");
    let formData = { ...formValue, ...{ [name]: santisedValue } };
    setFormValue(formData);
  };

  const [UserID, setUserID, UserIDref] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("VTXToken");
    const VTX = token.split("_")[1];
    setUserID(VTX);
    const urls = window.location.href;
    const chat = urls.split("/").pop();
    setheadurl(chat);
    let socket_token = sessionStorage.getItem("socketToken");
    let socketsplit = socket_token?.split(`"_`);
    socket.connect();
    getProfile();

    socket.off("socketResponse");
    socket.on("socketResponse" + socketsplit[0], function (res) {
      if (res.Reason == "p2pchat") {
        getp2pChat();
      } else if (res.Reason == "notify") {
        setnotifymessage(res.Message);
        showsuccessToast(res.Message, {
          toastId: "3",
        });
        getp2pOrder();
        getconfirmOrder();
      } else if (res.Reason == "ordercancel") {
        setnotifymessage(res.Message);
        showsuccessToast(res.Message, {
          toastId: "3",
        });
        getp2pOrder();
        getconfirmOrder();
        getAdminChat();
      }
    });

    socket.emit("socketResponse");
  }, [0]);

  useEffect(() => {
    checkdiputes();
    return () => {
      socket.disconnect();
    };
  }, []);
const [adminvisbile,setadminvisbile]=useState(false)
const [disputeData,setdisputeData]=useState()
const [disuserputeData,setdisuserputeData]=useState()

  const checkdiputes = async ()=>{
     try {
      var obj={
         orderId: headurlref.current,
      }
      var data = {
        apiUrl: apiService.checkdiputes,
        payload:obj
      };
      var resp = await postMethod(data);
      if (resp.status==true) {
        // if(resp.data.resolveStatus==2 ||resp.data.resolveStatus==3){
        // setadminvisbile(false);
        // }else{
       if(resp.data.resolveStatus==3 ){
        setadminvisbile(true);
        }
        setdisputeData(resp.data);
        setdisuserputeData(resp.p2puserdisputes);
        setdisputequery(resp.data.query);
        }
    } catch (error) {}
  }
  const restrictresolve = ()=>{
    showerrorToast("Your dispute is already resolved,if any query contact administrator via mail");
    setadminvisbile(false);
  }
    const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 });
useEffect(() => {                   
  console.log(disputeData,"disputeData")
    const endTime = Moment(disputeData?.apealendtime);
    const interval = setInterval(() => {
      const now = Moment();
      const diff = Moment.duration(endTime.diff(now));

      if (diff.asMilliseconds() <= 0) {
        clearInterval(interval);
        setTimeLeft({ minutes: 0, seconds: 0 });
      } else {
        const minutes = Math.floor(diff.asMinutes());
        const seconds = Math.floor(diff.seconds());
        setTimeLeft({ minutes, seconds });
      }
    }, 1000);
console.log(timeLeft,"--")
    return () => clearInterval(interval); // Cleanup
  }, [disputeData]);
  const resolve = async (status)=>{
    try{
  var obj={
         status:status,
         disputeId:disputeData._id
      }
      var data = {
        apiUrl: apiService.resolve,
        payload:obj
      };
      var resp = await postMethod(data);
      if (resp.status==true) {
         showsuccessToast(resp.Message); 
         navigate("/p2p")       
        }else{
         showerrorToast(resp.Message);
        }
    }catch(error){

    }
  }
  const getProfile = async () => {
    try {
      setSiteLoader(true);
      var data = {
        apiUrl: apiService.getUserDetails,
      };
      var resp = await getMethod(data);

      if (resp.status) {
        setSiteLoader(false);
        if (resp.Message != null) {
          setprofileData(resp.Message);
          setprofileStatus(true);
          if (profileStatusref.current != null) {
            getp2pOrder();
            getp2pChat();
          }
        }
      }
    } catch (error) {}
  };

  const getp2pOrder = async () => {
    setSiteLoader(true);
    var onj = {
      orderId: headurlref.current,
    };
    var data = {
      apiUrl: apiService.getp2pOrder,
      payload: onj,
    };
    var resp = await postMethod(data);

    if (resp) {
      setSiteLoader(false);

      var data = resp.Message;
      setp2pData(resp.Message);

      setp2pbalance(resp.p2pbalance);

      let paymentTime =
        resp.Message.pay_time != null && resp.Message.pay_time != ""
          ? parseInt(resp.Message.pay_time)
          : "15";
      setpayTime(paymentTime);
      // if (resp.bank) {
      if (UserIDref.current == resp.user_id) {
        setbankData(resp.opp_userbank);
      } else if (UserIDref.current == resp.opp_user_id) {
        setbankData(resp.user_bank);
      }
      // }

      if (profileDataref.current != null) {
        if (resp.Message.orderType == "buy") {
          if (UserIDref.current == resp.Message.userId._id) {
            setorderType("Buy");
          } else {
            setorderType("Sell");
          }
        } else {
          if (UserIDref.current == resp.Message.userId._id) {
            setorderType("Sell");
          } else {
            setorderType("Buy");
          }
        }
      }

      var dates = Moment(resp.Message.createdAt).format("DD.MM.YYYY h:m a");
      setp2pDate(dates);
      setp2pRating(resp.rating);
      setp2pOrdercount(resp.completed_count);
      getconfirmOrder();
    }
  };

  const getp2pconfirmOrder = async () => {
    var onj = {
      orderId: headurlref.current,
    };
    var data = {
      apiUrl: apiService.p2p_confirm_check,
      payload: onj,
    };
    setSiteLoader(true);

    var resp = await postMethod(data);
    setSiteLoader(false);

    if (resp) {
      var data = resp.Message;
      setconfirmp2pcheck(resp.Message);
    }
  };

  const getconfirmOrder = async () => {
    var onj = {
      orderId: headurlref.current,
    };
    setSiteLoader(true);
    var data = {
      apiUrl: apiService.confirmp2porder,
      payload: onj,
    };
    var resp = await postMethod(data);
    setSiteLoader(false);
    if (resp) {
      var data = resp.Message;
      setconfirmp2porder(resp.Message);
      if (resp.Message.status == 0) {
        var timer =
          new Date(resp.Message.datetime).getTime() +
          payTimeref.current * 60 * 1000;
        var current_time = new Date().getTime();

        if (timer > current_time) {
          setTimerstatus("active");
          // console.log(
          //   UserIDref.current,
          //   p2pDataref.current,
          //   orderTyperef.current,
          //   confirmp2porderref.current.status
          // );
          setTimer(timer);
        }
      } else if (resp.Message.status == 1) {
        var timer = new Date(resp.Message.paytime).getTime() + 15 * 60 * 1000;
        var current_time = new Date().getTime();
        if (timer > current_time) {
          setsellTimerstatus("active");
          setsellTimer(timer);
        }
      }

      setp2pbankData(resp.bank_details);
      setp2pbankcheck(true);
    }
  };

  const renderer_sell = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      cancel_confirmorder_sell();
    } else {
      return (
        <div className="timer_section1">
          <div className="timer-sect">
            <span>{hours}h</span> :<span>{minutes}m</span> :
            <span>{seconds}s</span>
          </div>
        </div>
      );
    }
  };

  const handleChange_buycancel = async (e) => {
    e.preventDefault();
    buyer_cancel();
  };

  const cancel_confirmorder_sell = async () => {
    var onj = {
      orderId: window.location.href.split("/").pop(),
    };
    setSiteLoader(true);

    var data = {
      apiUrl: apiService.cancelConfirmSell,
      payload: onj,
    };
    var resp = await postMethod(data);
    setSiteLoader(false);

    if (resp.status) {
      setsellTimerstatus("deactive");
      setsellTimer("");
    }
  };

  const buyer_confirmation = async (status) => {
    try {
      var order_Id = window.location.href.split("/").pop();
      var obj = {
        orderId: window.location.href.split("/").pop(),
        status: status,
      };
      setSiteLoader(true);

      var data = {
        apiUrl: apiService.buyer_confirm,
        payload: obj,
      };
      setconfirmloader(true);
      var resp = await postMethod(data);
      setconfirmloader(false);
      setSiteLoader(false);

      if (resp.status) {
        // navigate(`/p2p/complete/${order_Id}`)
        showsuccessToast(resp.Message);
        getp2pChat();
        getp2pOrder();
        getconfirmOrder();
      } else {
        showerrorToast(resp.Message);
      }
    } catch (error) {}
  };

  const submitChat = async () => {
    try {
      formValue.file = p2pfileref.current;
      formValue.orderId = window.location.href.split("/").pop();
      formValue.p2porderId = confirmp2porderref.current._id;
      formValue.type =
        UserIDref.current == p2pDataref.current.userId._id
          ? "advertiser"
          : "user";
      formValue.chatType =chatTabBtnref.current=="user"?"":"admin"
          
      if (formValue.message != "" || formValue.file != "") {
        var data = {
          apiUrl: apiService.p2pchat,
          payload: formValue,
        };
        setchatloading(true);
        var resp = await postMethod(data);
        formValue.message = "";

        if (resp.status) {
          setchatloading(false);
          getp2pChat();
          setRunningTimer(true);
          setp2pfile("");
          getAdminChat()
        } else {
          showerrorToast(resp.Message);
        }
      } else {
        showerrorToast("Please enter message");
      }
    } catch (error) {}
  };
  const seller_confirmation = async (status) => {
    try {
      var order_Id = window.location.href.split("/").pop();

      var obj = {
        orderId: window.location.href.split("/").pop(),
        status: status,
      };
      var data = {
        apiUrl: apiService.seller_confirm,
        payload: obj,
      };
      setconfirmloader(true);
      var resp = await postMethod(data);

      if (resp.status) {
        setconfirmloader(false);
        navigate("/p2p");
        showsuccessToast(resp.Message);
        getp2pOrder();
        getconfirmOrder();
        setRunningTimer(false);
        clearInterval(intervalref.current);
      } else {
        showerrorToast(resp.Message);
      }
    } catch (error) {}
  };

  const buyer_cancel = async (status) => {
    try {
      var obj = {
        orderId: window.location.href.split("/").pop(),
        status: status,
      };
      setSiteLoader(true);

      var data = {
        apiUrl: apiService.buyer_pay_cancel,
        payload: obj,
      };

      var resp = await postMethod(data);

      setSiteLoader(false);

      if (resp.status) {
        showerrorToast(resp.Message);
        getp2pChat();
        getp2pOrder();
        navigate("/p2p");
      } else {
        showerrorToast(resp.Message);
      }
    } catch (error) {}
  };

  const handleChange_confirm = async (e) => {
    e.preventDefault();
    if (e.target.innerText == "Confirm Payment") {
      buyer_confirmation("Completed");
    } else if (e.target.innerText == "Confirm Release") {
      seller_confirmation("Completed");
    }
  };

  const cancel_confirm_buy = async () => {
    var onj = {
      orderId: window.location.href.split("/").pop(),
    };
    setSiteLoader(true);

    var data = {
      apiUrl: apiService.cancelConfirmBuy,
      payload: onj,
    };
    var resp = await postMethod(data);

    setSiteLoader(false);

    if (resp.status) {
      setTimerstatus("deactive");
      setTimer("");
      showerrorToast(resp.Message);
      navigate("/p2p");
    }
  };

  const dispute_handleChange = async (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let values = e.target.value;

    if (values == "") {
      seterrortext("Reason is required");
    } else {
      seterrortext("");
    }
    if (values.startsWith(" ")) {
      values = values.trimStart();
    }
    setdisputequery(values);
  };

  const [raiseloader, setraiseloader, raiseloaderref] = useState(false);
  const [raiseValid, setraiseValid] = useState(0);
  const [raisename, setraisename, raisenameref] = useState("");
  const [model3, setmodel3, model3ref] = useState(true);

  const disputeUpload = (type, val) => {
    setraiseloader(true);
    const fileExtension = val.name.split(".").at(-1);
    const fileSize = val.size;
    const fileName = val.name;
    if (
      fileExtension != "png" &&
      fileExtension != "jpg" &&
      fileExtension != "jpeg" &&
      fileExtension != "pdf" &&
      fileExtension != "doc" &&
      fileExtension != "docx"
    ) {
      setraiseloader(false);
      showerrorToast(
        "File does not support. You must use .png, .jpg,  .jpeg,  .pdf,  .doc,  .docx "
      );
      return false;
    } else if (fileSize > 10000000) {
      setraiseloader(false);

      showerrorToast("Please upload a file smaller than 1 MB");
      return false;
    } else {
      const data = new FormData();
      data.append("file", val);
      data.append("upload_preset", "sztbiwly");
      data.append("cloud_name", "taikonz-com");
      fetch("  https://api.cloudinary.com/v1_1/taikonz-com/auto/upload", {
        method: "post",
        body: data,
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (type == "file") {
            setraiseValid(1);
            setdisputefile(data.secure_url);
            setraisename(fileName);
          }
          setraiseloader(false);
        })
        .catch((err) => {
          setraiseloader(false);
        });
    }
  };

  const dispute_buy = async () => {
    try {
      var obj = {};
      obj.type = "buy";
      obj.query = disputequeryref.current;
      obj.attachment = disputefileref.current;
      obj.orderId = confirmp2porderref.current.orderId;
      obj.p2p_orderId = window.location.href.split("/").pop();
      if (obj.query != "") {
        seterrortext("");

        var data = {
          apiUrl: apiService.raise_dispute,
          payload: obj,
        };
        setSiteLoader(true);
        var resp = await postMethod(data);
        setSiteLoader(false);
        if (resp.status) {
          showsuccessToast(resp.Message);
          getp2pOrder();
          getp2pconfirmOrder();
          setdisputequery("");
          setdisputefile("");
          setraisename("");
          window.location.reload();
        } else {
          showerrorToast(resp.Message);
        }
      } else {
        seterrortext("Reason is required");
        // showerrorToast("Please enter reason and proof for dispute");
      }
    } catch (error) {}
  };

  const [errortext, seterrortext] = useState(false);
  const dispute_sell = async () => {
    try {
      var obj = {};
      obj.type = "sell";
      obj.query = disputequeryref.current;
      obj.attachment = disputefileref.current;
      obj.orderId = confirmp2porderref.current.orderId;
      obj.p2p_orderId = window.location.href.split("/").pop();

      if (obj.query != "") {
        seterrortext("");
        var data = {
          apiUrl: apiService.raise_dispute,
          payload: obj,
        };
        setSiteLoader(true);

        var resp = await postMethod(data);
        setSiteLoader(false);

        if (resp.status) {
          showsuccessToast(resp.Message);
          getp2pOrder();
          getp2pconfirmOrder();
          setdisputequery("");
          setdisputefile("");
          setraisename("");
          window.location.reload();
        } else {
          showerrorToast(resp.Message);
        }
      } else {
        seterrortext("Reason is required");
      }
    } catch (error) {}
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      cancel_confirm_buy();
    } else {
      return (
        <div className="timer_section1">
          <div className="timer-sect">
            <span>{hours}h</span> :<span>{minutes}m</span> :
            <span>{seconds}s</span>
          </div>
        </div>
      );
    }
  };

  const copy_to_clipboard = async (type, text) => {
    navigator.clipboard.writeText(text);
    showsuccessToast(type + " copied successfully");
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  // console.log
  //    (profileDataref.current ,"profileDataref.current",
  //     UserIDref.current != p2pDataref.current.userId?._id ,"UserIDref.current != p2pDataref.current.userId?._id ",
  //     orderTyperef.current == "Buy" ,"orderTyperef.current",
  //     confirmp2porderref.current.status ,"confirmp2porderref.current.status",
  //     UserIDref.current,"UserIDref.current",p2pDataref.current.userId?._id,"p2pDataref.current.userId?._id,","......",
  //     confirmp2porderref.current.paymentMethod,"confirmp2porderref.current.paymentMethod"
  //   )

  // new dropdown
  const [selectedReason, setSelectedReason] = useState(
    "I haven't received payment from the seller"
  );

  const reasons = [
    "I haven't received payment from the seller.",
    "I haven't received payment from the Buyer.",
    "The buyer paid less than the required amount.",
    "After I received the payment, my account got frozen.",
    "The name of the payer is different from the name of the buyer on the platform",
  ];


  // dispute details
  const [chatTabBtn, setChatTabBtn,chatTabBtnref] = useState("user");

  const handleChatTabClick = (tab) => {
    console.log(adminvisbile,"adminvisbile")
    if(tab =="admin" && adminvisbile == true ){
    setChatTabBtn(tab);
    getAdminChat()
    }else if (tab =="user" ){
    setChatTabBtn(tab);
    getp2pChat()
    }
    // else{
    // // showerrorToast("Not ")
    // setChatTabBtn('user');
    // getp2pChat()
    // }
    console.log(chatTabBtnref.current,"chatTabBtn")
  };

  // image selection ==> chat
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedImage(URL.createObjectURL(file));
  //   }
  // };
  
  const handleImageChange = (type, val) => {
    const fileExtension = val.name.split(".").at(-1);
    const fileSize = val.size;
    const fileName = val.name;
    if (
      fileExtension != "png" &&
      fileExtension != "jpg" &&
      fileExtension != "jpeg" &&
      fileExtension != "pdf" &&
      fileExtension != "doc" &&
      fileExtension != "docx"
    ) {
      showerrorToast(
        "File does not support. You must use .png, .jpg,  .jpeg,  .pdf,  .doc,  .docx "
      );
      return false;
    } else if (fileSize > 10000000) {
      showerrorToast("Please upload a file smaller than 1 MB");
      return false;
    } else {
      const data = new FormData();
      data.append("file", val);
      data.append("upload_preset", "sztbiwly");
      data.append("cloud_name", "taikonz-com");
      fetch("  https://api.cloudinary.com/v1_1/taikonz-com/auto/upload", {
        method: "post",
        body: data,
      })
        .then((resp) => resp.json())
        .then((data) => {
         setSelectedImage(URL.createObjectURL(val));
          if (type == "file") {
            setSelectedImage(data.secure_url);
          }
        })
        .catch((err) => {
        });
    }
  };
  const handleRemoveImage = () => {
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
const [chatData,setChatData,chatDataref]= useState([]);

const getAdminChat= async ()=>{
    setSiteLoader(true);

  console.log(headurlref.current,"headurlref.current")
     var obj = {
      orderId: headurlref.current,
    };
    try{
        const data = {
        apiUrl: apiService.getAdminChat,
        payload: obj,
      };
      var response = await postMethod(data);
    setSiteLoader(false);
      // setp2pchat([])
      console.log(response.data)
      // if (response.status==true) {
        setChatData(response.data);
      // }else{
      //   setChatData([]);
      // }
      console.log(chatDataref.current)
    }catch(error){

    }
  };

  return (
    <>
      <section className="Non_fixed_nav">
        <Header />
      </section>{" "}
      <div>
        {siteLoader == true ? (
          <div className="loadercss">
            <Bars
              height="80"
              width="80"
              color="#ffc630"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <div className="Verification">
            <div className="container-xxl">
              <div className="nw_payment_box">
                <div className="row justify-content-center mx-0">
                  <div className="col-md-5 p2p_dis_lft_col">
                    <div className="p2p_dis_lft">
                      <h5 className="pay-title">
                        {orderTyperef.current == "Buy" ? (
                          <h1 className="mb-4">
                            You are buying {p2pDataref.current.firstCurrency}
                          </h1>
                        ) : (
                          <h1 className="mb-4">
                            You are selling {p2pDataref.current.firstCurrency}
                          </h1>
                        )}
                      </h5>
                      {profileDataref.current != null ? (
                        orderTyperef.current == "Buy" &&
                        profileDataref.current._id ==
                          p2pDataref.current.user_id &&
                        confirmp2porderref.current.status == 0 &&
                        Timerstatusref.current == "active" ? (
                          <p className="pay-content">
                            Complete the payment within{" "}
                            <span className="pay-span">
                              {p2pDataref.current.pay_time}
                            </span>{" "}
                            Otherwise, the order will be canceled
                          </p>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      <div className="pay-wrapper-two">
                        <div className="pay-flex">
                          <span className="pay-btc">Order Details</span>
                        </div>

                        <div className="pay-flex">
                          <span className="pay-name">Price</span>
                          <span className="pay-money">
                            {parseFloat(p2pDataref.current.price).toFixed(2)}{" "}
                            <span className="pay-name">
                              {" "}
                              {p2pDataref.current.secondCurrnecy}{" "}
                            </span>{" "}
                          </span>
                        </div>

                        <div className="pay-flex">
                          <span className="pay-name">Amount</span>
                          <span className="pay-money">
                            {confirmp2porderref.current.askAmount}{" "}
                            <span className="pay-btc">
                              {" "}
                              {p2pDataref.current.firstCurrency}
                            </span>
                          </span>
                        </div>

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Sell" ? (
                            <div className="pay-flex">
                              <span className="pay-name">Will Receive</span>
                              <span className="pay-btc">
                                {parseFloat(
                                  p2pDataref.current.price *
                                    confirmp2porderref.current.askAmount
                                ).toFixed(2)}{" "}
                                {p2pDataref.current.secondCurrnecy}
                              </span>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          UserIDref.current != p2pDataref.current.userId?._id &&
                          orderTyperef.current == "Buy" &&
                          confirmp2porderref.current.status == 0 ? (
                            <>
                              {confirmp2porderref.current.paymentMethod ==
                                "BankTransfer" ||
                              confirmp2porderref.current.paymentMethod ==
                                "IMPS" ? (
                                bankDataref.current ? (
                                  <div className="color_border ne_bg_txt">
                                    <div className="pay-wrapper">
                                      <div className="pay-flex">
                                        <span className="pay-method">
                                          Payment Method
                                        </span>
                                        <span className="pay-bank">
                                          {p2pDataref.current.paymentMethod ==
                                          "UPID"
                                            ? "UPI ID"
                                            : p2pDataref.current.paymentMethod}
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-method">
                                          Selected Payment Method
                                        </span>
                                        <span className="pay-bank">
                                          {/* {confirmp2porderref.current.paymentMethod} */}
                                          {confirmp2porderref.current
                                            .paymentMethod == "UPID"
                                            ? "UPI ID"
                                            : confirmp2porderref.current
                                                .paymentMethod}
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Account Number
                                        </span>
                                        <span className="pay-money">
                                          {bankDataref.current.Account_Number}{" "}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Account Number",
                                                bankDataref.current
                                                  .Account_Number
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Account Holder
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {
                                            bankDataref.current
                                              .Accout_HolderName
                                          }
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Account Holder Name",
                                                bankDataref.current
                                                  .Accout_HolderName
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Bank Name
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.Bank_Name}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Bank Name",
                                                bankDataref.current.Bank_Name
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Branch Name
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.Branch_Name}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Branch Name",
                                                bankDataref.current.Branch_Name
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>

                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          IFSC Code
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.IFSC_code}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "IFSC Code",
                                                bankDataref.current.IFSC_code
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                // bankDataref.current ? (
                                <div className="color_border ne_bg_txt">
                                  <div className="pay-wrapper">
                                    <div className="pay-flex">
                                      <span className="pay-method">
                                        Payment Method
                                      </span>
                                      <span className="pay-bank">
                                        {p2pDataref.current.paymentMethod ==
                                        "UPID"
                                          ? "UPI ID"
                                          : p2pDataref.current.paymentMethod}
                                      </span>
                                    </div>
                                    <div className="pay-flex">
                                      <span className="pay-method">
                                        Selected Payment Method
                                      </span>
                                      <span className="pay-bank">
                                        {confirmp2porderref.current
                                          .paymentMethod == "UPID"
                                          ? "UPI ID"
                                          : confirmp2porderref.current
                                              .paymentMethod}
                                      </span>
                                    </div>
                                    <div className="pay-flex">
                                      <span className="pay-name">
                                        Account Holder Name
                                      </span>
                                      <span className="pay-money">
                                        {
                                          p2pbankDataref.current
                                            .Accout_HolderName
                                        }{" "}
                                        <i
                                          class="ri-file-copy-line cursor-pointer"
                                          onClick={() =>
                                            copy_to_clipboard(
                                              "Account Holder Name",
                                              p2pbankDataref.current
                                                .Accout_HolderName
                                            )
                                          }
                                        ></i>
                                      </span>
                                    </div>

                                    <div className="pay-flex">
                                      <span className="pay-name">
                                        {confirmp2porderref.current
                                          .paymentMethod == "Paytm"
                                          ? "Paytm ID"
                                          : "UPI ID"}
                                      </span>

                                      <span className="pay-money">
                                        {p2pbankDataref.current.Upid_ID}{" "}
                                        {confirmp2porderref.current
                                          .paymentMethod == "Paytm" ? (
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Paytm ID",
                                                p2pbankDataref.current.Upid_ID
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "UPI ID",
                                                p2pbankDataref.current.Upid_ID
                                              )
                                            }
                                          ></i>
                                        )}
                                        {/* <i
                                      class="ri-file-copy-line cursor-pointer"
                                      onClick={() =>
                                        copy_to_clipboard(
                                          "UPI ID",
                                          p2pbankDataref.current.Upid_ID
                                        )
                                      }
                                    ></i> */}
                                      </span>
                                    </div>

                                    <div className="pay-flex">
                                      <span className="pay-name mt-4">
                                        Payment QR Code
                                      </span>
                                      <span className="pay-money">
                                        <img
                                          src={p2pbankDataref.current.QRcode}
                                          width="150px"
                                          className=" setimagesize"
                                          alt="Payment QR Code"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                // ) : (
                                //   "bann"
                              )}
                            </>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          UserIDref.current == p2pDataref.current.userId?._id &&
                          orderTyperef.current == "Buy" &&
                          confirmp2porderref.current.status == 0 ? (
                            <>
                              {confirmp2porderref.current.paymentMethod ==
                                "BankTransfer" ||
                              confirmp2porderref.current.paymentMethod ==
                                "IMPS" ? (
                                bankDataref.current ? (
                                  <div className="color_border ne_bg_txt">
                                    <div className="pay-wrapper">
                                      <div className="pay-flex">
                                        <span className="pay-method">
                                          Payment Method
                                        </span>
                                        <span className="pay-bank">
                                          {p2pDataref.current.paymentMethod ==
                                          "UPID"
                                            ? "UPI ID"
                                            : p2pDataref.current.paymentMethod}
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-method">
                                          Selected Payment Method
                                        </span>
                                        <span className="pay-bank">
                                          {confirmp2porderref.current
                                            .paymentMethod == "UPID"
                                            ? "UPI ID"
                                            : confirmp2porderref.current
                                                .paymentMethod}
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Account Number
                                        </span>
                                        <span className="pay-money">
                                          {bankDataref.current.Account_Number}{" "}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Account Number",
                                                bankDataref.current
                                                  .Account_Number
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Account Holder
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {
                                            bankDataref.current
                                              .Accout_HolderName
                                          }
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Account Holder Name",
                                                bankDataref.current
                                                  .Accout_HolderName
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Bank Name
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.Bank_Name}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Bank Name",
                                                bankDataref.current.Bank_Name
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          Branch Name
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.Branch_Name}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Branch Name",
                                                bankDataref.current.Branch_Name
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>

                                      <div className="pay-flex">
                                        <span className="pay-name">
                                          IFSC Code
                                        </span>
                                        <span className="pay-money">
                                          {" "}
                                          {bankDataref.current.IFSC_code}
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "IFSC Code",
                                                bankDataref.current.IFSC_code
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )
                              ) : (
                                //  bankDataref.current ? (
                                <div className="color_border ne_bg_txt">
                                  <div className="pay-wrapper">
                                    <div className="pay-flex">
                                      <span className="pay-method">
                                        Payment Method
                                      </span>
                                      <span className="pay-bank">
                                        {p2pDataref.current.paymentMethod ==
                                        "UPID"
                                          ? "UPI ID"
                                          : p2pDataref.current.paymentMethod}
                                      </span>
                                    </div>
                                    <div className="pay-flex">
                                      <span className="pay-method">
                                        Selected Payment Method
                                      </span>
                                      <span className="pay-bank">
                                        {confirmp2porderref.current
                                          .paymentMethod == "UPID"
                                          ? "UPI ID"
                                          : confirmp2porderref.current
                                              .paymentMethod}
                                      </span>
                                    </div>
                                    <div className="pay-flex">
                                      <span className="pay-name">
                                        Account Holder Name
                                      </span>
                                      <span className="pay-money">
                                        {bankDataref.current.Accout_HolderName}{" "}
                                        <i
                                          class="ri-file-copy-line cursor-pointer"
                                          onClick={() =>
                                            copy_to_clipboard(
                                              "Account Holder Name",
                                              bankDataref.current
                                                .Accout_HolderName
                                            )
                                          }
                                        ></i>
                                      </span>
                                    </div>

                                    <div className="pay-flex">
                                      <span className="pay-name">
                                        {confirmp2porderref.current
                                          .paymentMethod == "Paytm"
                                          ? "Paytm ID"
                                          : "UPI ID"}
                                      </span>
                                      <span className="pay-money">
                                        {bankDataref.current.Upid_ID}{" "}
                                        {confirmp2porderref.current
                                          .paymentMethod == "Paytm" ? (
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "Paytm ID",
                                                bankDataref.current.Upid_ID
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          <i
                                            class="ri-file-copy-line cursor-pointer"
                                            onClick={() =>
                                              copy_to_clipboard(
                                                "UPI ID",
                                                bankDataref.current.Upid_ID
                                              )
                                            }
                                          ></i>
                                        )}
                                        {/* <i
                                      class="ri-file-copy-line cursor-pointer"
                                      onClick={() =>
                                        copy_to_clipboard(
                                          " UPI ID",
                                          bankDataref.current.Upid_ID
                                        )
                                      }
                                    ></i> */}
                                      </span>
                                    </div>

                                    <div className="pay-flex">
                                      <span className="pay-name mt-4">
                                        Payment QR Code
                                      </span>
                                      <span className="pay-money">
                                        <img
                                          src={bankDataref.current.QRcode}
                                          width="150px"
                                          className=" setimagesize"
                                          alt="Payment QR Code"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                // ) : (
                                // ""
                              )}

                              <p className="preview mt-3 timer_element">
                                Please do the payment in:{" "}
                                <span className="primary_red">
                                  {payTimeref.current} minutes
                                </span>
                              </p>
                            </>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {/* Sell function  */}
                        {/* {profileDataref.current != null ? (
                      orderTyperef.current == "Sell" &&
                        UserIDref.current == p2pDataref.current.userId?._id &&
                        confirmp2porderref.current.status == 1 &&
                        sellTimerstatusref.current == "active" ? (
                        <div className="timer">
                          <h6>
                            Release the crypto within 15 minutes
                            <span>
                              <Countdown
                                date={sellTimerref.current}
                                renderer={renderer_sell}
                              />
                            </span>
                          </h6>
                          <p className="pay-name mt-4" >- Buyer paid the amount</p>
                          <p className="pay-name">- Release the crypto within 15 minutes</p>
                          <p className="pay-name">
                            - If you are not release within 15 mintutes, order
                            will be Cancel automatically
                          </p>
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )} hide for jo */}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Sell" &&
                          UserIDref.current == p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 1 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading">
                              <div className="aling_caseds justify-content-end">
                                {confirmorderloader == false ? (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                    onClick={handleChange_confirm}
                                  >
                                    Confirm Release
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                  >
                                    Processing.....
                                  </button>
                                )}

                                {/* <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_sell"
                                >
                                  Raise Dispute
                                </button> */}
                                    
                               {disuserputeData?.resolveStatus==2 ||disuserputeData?.resolveStatus==3?
                                //    <button
                                //   type="button"
                                //   class="proceed-btn txt-center"
                                //   onClick={restrictresolve}
                                // >
                                //   Raise Dispute
                                // </button>""
                                ""
                                : disputeData?.resolveStatus == 1 && disuserputeData ?
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3"
                                    onClick={checkdiputes}
                                >
                                  Raise Dispute
                                </button>
                                :<button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy"
                                >
                                  Raise Dispute
                                </button>}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {/* {profileDataref.current != null ? (
                      orderTyperef.current == "Sell" &&
                        UserIDref.current != p2pDataref.current.userId?._id &&
                        confirmp2porderref.current.status == 1 &&
                        sellTimerstatusref.current == "active" ? (
                        <div className="timer">
                          <h6>
                            Release the crypto within 15 minutes
                            <span>
                              <Countdown
                                date={sellTimerref.current}
                                renderer={renderer_sell}
                              />
                            </span>
                          </h6>
                          <p className="pay-name mt-4">- Buyer paid the amount</p>
                          <p className="pay-name">- Release the crypto within 15 minutes</p>
                          <p className="pay-name">
                            - If you are not release within 15 mintutes, order
                            will be disputed automatically
                          </p>
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )} hide for jothi */}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Sell" &&
                          UserIDref.current != p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 1 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading">
                              <div className="aling_caseds justify-content-end">
                                {confirmorderloader == false ? (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                    onClick={handleChange_confirm}
                                  >
                                    Confirm Release
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                  >
                                    Processing.....
                                  </button>
                                )}
                                    
                               {disuserputeData?.resolveStatus==2 ||disuserputeData?.resolveStatus==3?
                                //    <button
                                //   type="button"
                                //   class="proceed-btn txt-center"
                                //   onClick={restrictresolve}
                                // >
                                //   Raise Dispute
                                // </button>""
                                ""
                                : disputeData?.resolveStatus == 1 && disuserputeData?
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3"
                                    onClick={checkdiputes}
                                >
                                  Raise Dispute
                                </button>
                                :<button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy"
                                >
                                  Raise Dispute
                                </button>}
{/* 
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_sell"
                                >
                                  Raise Dispute
                                </button> */}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current == p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 0 &&
                          Timerstatusref.current == "active" ? (
                            <div className="timer">
                              <h6>
                                Payment to be made within{" "}
                                {payTimeref.current < 60
                                  ? payTimeref.current + " minutes"
                                  : payTimeref.current / 60 == 1
                                  ? payTimeref.current / 60 + " hour"
                                  : payTimeref.current / 60 + " hours"}{" "}
                                <span>
                                  <Countdown
                                    date={Timerref.current}
                                    renderer={renderer}
                                  />
                                </span>
                              </h6>
                              <p className="pay-name mt-4">- Please pay fast</p>
                              {/* <p className="pay-name">- Do not accept third party payment</p> */}
                              <p className="pay-name">
                                - If you are not pay within{" "}
                                {payTimeref.current < 60
                                  ? payTimeref.current + " minutes"
                                  : payTimeref.current / 60 == 1
                                  ? payTimeref.current / 60 + " hour"
                                  : payTimeref.current / 60 + " hours"}
                                , order will be cancelled automatically
                              </p>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current == p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 0 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading">
                              <div className="aling_caseds justify-content-end">
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  onClick={handleChange_buycancel}
                                >
                                  Cancel
                                </button>

                                {confirmorderloader == false ? (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                    onClick={handleChange_confirm}
                                  >
                                    Confirm Payment
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                  >
                                    Processing.....
                                  </button>
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current != p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 0 &&
                          Timerstatusref.current == "active" ? (
                            <div className="timer">
                              <h6>
                                Payment to be made within{" "}
                                {payTimeref.current < 60
                                  ? payTimeref.current + " minutes"
                                  : payTimeref.current / 60 == 1
                                  ? payTimeref.current / 60 + " hour"
                                  : payTimeref.current / 60 + " hours"}{" "}
                                <span>
                                  <Countdown
                                    date={Timerref.current}
                                    renderer={renderer}
                                  />
                                </span>
                              </h6>
                              <p className="pay-name mt-4">- Please pay fast</p>
                              {/* <p className="pay-name">- Do not accept third party payment</p> */}
                              <p className="pay-name">
                                - If you are not pay within{" "}
                                {payTimeref.current < 60
                                  ? payTimeref.current + " minutes"
                                  : payTimeref.current / 60 == 1
                                  ? payTimeref.current / 60 + " hour"
                                  : payTimeref.current / 60 + " hours"}{" "}
                                order will be cancelled automatically
                              </p>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current != p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 0 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading cancel-payment-butns">
                              <div className="aling_caseds justify-content-star payment-cancel-confirm">
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  onClick={handleChange_buycancel}
                                >
                                  Cancel
                                </button>

                                {confirmorderloader == false ? (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                    onClick={handleChange_confirm}
                                  >
                                    Confirm Payment
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    class="proceed-btn txt-center"
                                  >
                                    Processing.....
                                  </button>
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current != p2pDataref.current.userId?._id &&
                          confirmp2porderref.current.status == 1 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading">
                              <div className="aling_caseds justify-content-end">
                                
                               {disuserputeData?.resolveStatus==2 ||disuserputeData?.resolveStatus==3?
                                //    <button
                                //   type="button"
                                //   class="proceed-btn txt-center"
                                //   onClick={restrictresolve}
                                // >
                                //   Raise Dispute
                                // </button>""
                                ""
                                :disputeData?.resolveStatus == 1 && disuserputeData?
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3"
                                    onClick={checkdiputes}
                                >
                                  Raise Dispute
                                </button>
                                :<button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy"
                                >
                                  Raise Dispute
                                </button>}
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}

                        {profileDataref.current != null ? (
                          orderTyperef.current == "Buy" &&
                          UserIDref.current ==
                            p2pDataref.current?.userId?._id &&
                          confirmp2porderref.current.status == 1 ? (
                            <div class="form register_login  marhing_pading pl-0 paddinte_ledy_o pt-0 right_pading">
                              <div className="aling_caseds justify-content-end">
                               {/* {adminvisbile ==true ?
                                  <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3"
                                  onClick={checkdiputes}
                                >
                                  Raise Dispute
                                </button>
                               :
                                  <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy"
                                >
                                  Raise Dispute
                                </button>
                               } */}
                                   
                               {disuserputeData?.resolveStatus==2 ||disuserputeData?.resolveStatus==3?
                                //    <button
                                //   type="button"
                                //   class="proceed-btn txt-center"
                                //   onClick={restrictresolve}
                                // >
                                //   Raise Dispute
                                // </button>
                                "": disputeData?.resolveStatus == 1 && disuserputeData?
                                <button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3"
                                    onClick={checkdiputes}
                                >
                                  Raise Dispute
                                </button>
                                :<button
                                  type="button"
                                  class="proceed-btn txt-center"
                                  data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy"
                                >
                                  Raise Dispute
                                </button>}
                             
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                   {/* <div className="col-lg-6">
                    <div className="chat-box">
                      <div className="chat-flex">
                        <div className="p2p_namefrst_change align-items-center">
                          {p2pDataref.current.userId?.displayname
                            ? p2pDataref.current.userId.displayname[0]
                            : ""}
                        </div>
                        <div className="chat-content">
                          <span className="pay-btc">
                            {p2pDataref.current.userId?.displayname}
                          </span>
                          <span className="chat-para">
                            {p2pOrdercountref.current} Volume |{" "}
                            {parseFloat(p2pRatingref.current).toFixed(2)}%
                            Transaction rate
                          </span>
                        </div>
                      </div>
                      <div className="inner-box">
                        <div className="chat_section">
                          {profileDataref.current != null
                            ? p2pchatref.current &&
                              p2pchatref.current.map((chat, i) => {
                                return chat.type == "advertiser" ? (
                                  chat.user_id == UserIDref.current &&
                                  chat.default == 0 ? (
                                    <div className="char_recive w-100 d-flex justify-content-end">
                                      <div className=" char_send">
                                        <div className="chat_conent p_new_end">
                                          <p>
                                            {Moment(chat.createdAt).format(
                                              "LT"
                                            )}
                                          </p>

                                          {chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                            <div className="j-img-content-two">
                                              {chat.adv_msg}
                                            </div>
                                          ) : chat.user_msg != "" &&
                                            chat.user_msg != undefined ? (
                                            <div className="j-img-content-two">
                                              {chat.user_msg}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                            <img
                                              src={chat.adv_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : chat.user_file != "" &&
                                            chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : chat.user_id != UserIDref.current ? (
                                    <div className="char_recive">
                                      <div className="chat_conent">
                                        <p>
                                          {Moment(chat.createdAt).format("LT")}
                                        </p>

                                        {chat.user_msg != "" &&
                                        chat.user_msg != undefined ? (
                                          <div className="j-img-content-two">
                                            {chat.user_msg}
                                          </div>
                                        ) : chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                          <div className="j-img-content-two">
                                            {chat.adv_msg}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {chat.user_file != "" &&
                                        chat.user_file != undefined ? (
                                          <img
                                            src={chat.user_file}
                                            className=""
                                            width="250px"
                                          />
                                        ) : chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                          <img
                                            src={chat.adv_file}
                                            width="250px"
                                            className=""
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )
                                ) : chat.user_id == UserIDref.current &&
                                  chat.default == 0 ? (
                                  <div className="char_recive w-100 d-flex justify-content-end">
                                    <div className=" char_send">
                                      <div className="chat_conent p_new_end">
                                        <p>
                                          <span></span>{" "}
                                          {Moment(chat.createdAt).format("LT")}
                                        </p>

                                        {chat.user_msg != "" &&
                                        chat.user_msg != undefined ? (
                                          <div className="j-img-content-two">
                                            {chat.user_msg}
                                          </div>
                                        ) : chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                          <div className="j-img-content-two">
                                            {chat.adv_msg}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {chat.user_file != "" &&
                                        chat.user_file != undefined ? (
                                          <img
                                            src={chat.user_file}
                                            className=""
                                            width="250px"
                                          />
                                        ) : chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                          <img
                                            src={chat.adv_file}
                                            width="250px"
                                            className=""
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : chat.user_id != UserIDref.current ? (
                                  <div className="char_recive">
                                    <div className="chat_conent">
                                      <p>
                                        
                                        {Moment(chat.createdAt).format("LT")}
                                      </p>

                                      {chat.user_msg != "" &&
                                      chat.user_msg != undefined ? (
                                        <div className="j-img-content-two">
                                          {chat.user_msg}
                                        </div>
                                      ) : chat.adv_msg != "" &&
                                        chat.adv_msg != undefined ? (
                                        <div className="j-img-content-two">
                                          {chat.adv_msg}
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {chat.user_file != "" &&
                                      chat.user_file != undefined ? (
                                        <img
                                          src={chat.user_file}
                                          width="250px"
                                          className=""
                                        />
                                      ) : chat.adv_file != "" &&
                                        chat.adv_file != undefined ? (
                                        <img
                                          src={chat.adv_file}
                                          width="250px"
                                          className=""
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                );
                              })
                            : ""}
                        </div>
                      </div>

                      {confirmp2porderref.current.status == 3 ? (
                        ""
                      ) : confirmp2porderref.current.status != 2 ? (
                        <div className="start-wrapper">
                          <textarea
                            type="text"
                            placeholder="Start chat here"
                            name="message"
                            value={
                              formValue.message != "" ? formValue.message : ""
                            }
                            maxLength="250"
                            onChange={handleChange}
                            className="start-input"
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault(); // Prevent the default action (new line)
                                submitChat();
                              }
                            }}
                          />

                          {chatloading == false ? (
                            <div className="start-icon" onClick={submitChat}>
                              <img
                                src={require("../assets/start-arrow.png")}
                                alt=""
                              />
                            </div>
                          ) : (
                            <div className="start-icon">
                              <i class="fa-solid fa-spinner fa-spin p2p_chat_send"></i>
                            </div>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>  */}
                   <div className="col-md-7 p2p_dis_rgt">
                        <div className="p2p_dis_tabs_wrap">
                          <button
                            onClick={() => handleChatTabClick("user")}
                            className={`p2p_dis_tab_btn ${
                              chatTabBtnref.current === "user" ? "active" : ""
                            }`}
                          >
                            Chat With {""}
                             {/* <span>  */}

                               {orderTyperef.current == "Buy" ? (
                          <span >
                           Seller
                          </span>
                        ) : (
                          <span >
                            Buyer
                          </span>
                        )}
                              {/* {p2pDataref.current.userId?.displayname
                            ? p2pDataref.current.userId.displayname
                            : ""} */}
                            {/* </span>{" "} */}
                          </button>
                          <button
                            onClick={() => handleChatTabClick("admin")}
                            className={`ds_rgt_btn p2p_dis_tab_btn ${
                              chatTabBtnref.current === "admin" ? "active" : ""
                            } `}
                            // } ${adminvisbile ? "cursorpoint" : "cursornot"}`}
                          >
                            Chat With{" "}
                            <span>
                              <img
                                src={require("../assets/Logo.png")}
                                alt="Voltrix"
                                className="p2p_dis_tab_img"
                              />
                            </span>{" "}
                          </button>
                        </div>
{chatTabBtnref.current == "admin"?<>
 <div className="p2p_dis_chat">
  {chatDataref.current &&
                              chatDataref.current.map((chat, i) => {
                                console.log("-======",chat)
                                return chat.type == "user"&& chat.chatType == "admin"  ?<div className="p2p_dis_send_wrap">
                            <div className="dis_box_send_wrap">
                              <div className="dis_send_msg_box">
                                 {chat.user_msg != "" &&
                                          chat.user_msg != undefined ? (
                                            <span>
                                              {chat.user_msg}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                           {chat.user_file != "" &&
                                          chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>

                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                          </div>:
                          <div className="p2p_dis_receive_wrap">
                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                            <div className="dis_box_re_wrap">
                              <div className="dis_re_msg_box">
                                 {chat.admin_msg != "" &&
                                          chat.admin_msg != undefined ? (
                                            <span>
                                              {chat.admin_msg}
                                            </span>
                                          )  : (
                                            ""
                                          )}
                                           {chat.admin_file != "" &&
                                          chat.admin_file != undefined ? (
                                            <img
                                              src={chat.admin_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                              
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>
                          </div>})}
                                </div>
                                 <div className="p2p_dis_chat_btn_wrap">
                          <div className="p2p_dis_slct_img_wrap">
                            {!selectedImage ? (
                              <label
                                htmlFor="image_upload"
                                className="p2p_dis_slct_img"
                              >
                                <AddPhotoAlternateIcon />
                                <input
                                  type="file"
                                  id="image_upload"
                                  className="img_upld_icon"
                                  accept="image/*"
                                  ref={fileInputRef}
                                  // onChange={handleImageChange}
                                   onChange={(e) =>
                handleImageChange("file", e.target.files[0])
              }
                                  style={{ display: "none" }}
                                />
                              </label>
                            ) : (
                              <div className="preview_img_wrap">
                                <img
                                  src={selectedImage}
                                  alt="preview"
                                  className="preview_img_icon"
                                />
                                <span
                                  className="remove_img_btn"
                                  onClick={handleRemoveImage}
                                >
                                  <CloseIcon fontSize="small" />
                                </span>
                              </div>
                            )}
                          </div>

                          <span className="p2p_dis_chat_input">
                               <textarea
                            type="text"
                            placeholder="Start chat here"
                            name="message"
                            value={
                              formValue.message != "" ? formValue.message : ""
                            }
                            maxLength="250"
                            onChange={handleChange}
                            className="start-input"
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault(); // Prevent the default action (new line)
                                submitChat();
                              }
                            }}
                          />
                            {/* <input type="text" placeholder="Your Message" /> */}
                          </span>

                          <span className="p2p_dis_send_icon">
                              {chatloading == false ? (
                                <>
                                
                                                         <SendIcon  onClick={submitChat} />
</>
                          ) : (
                            <div className="start-icon">
                              <i class="fa-solid fa-spinner fa-spin p2p_chat_send"></i>
                            </div>
                          )}
                          </span>
                        </div>
                                </>:
                                <>
                        <div className="p2p_dis_chat">
  {profileDataref.current != null
                            ? p2pchatref.current &&
                              p2pchatref.current.map((chat, i) => {
                                return chat.type == "advertiser" ? (
                                  chat.user_id == UserIDref.current &&
                                  chat.default == 0 ? (
                          
                          <div className="p2p_dis_send_wrap">
                            <div className="dis_box_send_wrap">
                              <div className="dis_send_msg_box">
                                {/* <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span> */}
                                 {chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                            <span>
                                              {chat.adv_msg}
                                            </span>
                                          ) : chat.user_msg != "" &&
                                            chat.user_msg != undefined ? (
                                            <span>
                                              {chat.user_msg}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                           {chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                            <img
                                              src={chat.adv_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : chat.user_file != "" &&
                                            chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>

                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                          </div>
                                  ): chat.user_id != UserIDref.current ? (
                                    
                          <div className="p2p_dis_receive_wrap">
                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                            <div className="dis_box_re_wrap">
                              <div className="dis_re_msg_box">
                                 {chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                            <span>
                                              {chat.adv_msg}
                                            </span>
                                          ) : chat.user_msg != "" &&
                                            chat.user_msg != undefined ? (
                                            <span>
                                              {chat.user_msg}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                           {chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                            <img
                                              src={chat.adv_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : chat.user_file != "" &&
                                            chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                                {/* <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span> */}
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>
                          </div>):""): chat.user_id == UserIDref.current &&
                          chat.default == 0 ? (
                             <div className="p2p_dis_send_wrap">
                            <div className="dis_box_send_wrap">
                              <div className="dis_send_msg_box">
                                {/* <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span> */}
                                 {chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                            <span>
                                              {chat.adv_msg}
                                            </span>
                                          ) : chat.user_msg != "" &&
                                            chat.user_msg != undefined ? (
                                            <span>
                                              {chat.user_msg}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                           {chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                            <img
                                              src={chat.adv_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : chat.user_file != "" &&
                                            chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>

                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                          </div>):chat.user_id != UserIDref.current ? (
                             <div className="p2p_dis_receive_wrap">
                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                            <div className="dis_box_re_wrap">
                              <div className="dis_re_msg_box">
                                {/* <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span> */}
                                 {chat.adv_msg != "" &&
                                          chat.adv_msg != undefined ? (
                                            <span>
                                              {chat.adv_msg}
                                            </span>
                                          ) : chat.user_msg != "" &&
                                            chat.user_msg != undefined ? (
                                            <span>
                                              {chat.user_msg}
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                           {chat.adv_file != "" &&
                                          chat.adv_file != undefined ? (
                                            <img
                                              src={chat.adv_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : chat.user_file != "" &&
                                            chat.user_file != undefined ? (
                                            <img
                                              src={chat.user_file}
                                              width="250px"
                                              className=""
                                            />
                                          ) : (
                                            ""
                                          )}
                              </div>
                              <span> {Moment(chat.createdAt).format(
                                              "LT"
                                            )}</span>
                            </div>
                          </div>):("")}):""}
                          {/* <div className="p2p_dis_send_wrap">
                            <div className="dis_box_send_wrap">
                              <div className="dis_send_msg_box">
                                <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span>
                              </div>
                              <span>10:15 AM</span>
                            </div>

                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                          </div>
                          <div className="p2p_dis_receive_wrap">
                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                            <div className="dis_box_re_wrap">
                              <div className="dis_re_msg_box">
                                <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span>
                              </div>
                              <span>10:15 AM</span>
                            </div>
                          </div>
                          <div className="p2p_dis_send_wrap">
                            <div className="dis_box_send_wrap">
                              <div className="dis_send_msg_box">
                                <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span>
                              </div>
                              <span>10:15 AM</span>
                            </div>

                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                          </div> */}
                          {/* <div className="p2p_dis_receive_wrap">
                            <div className="p2p_dis_chat_person">
                              <img
                                src={require("../assets/chat-person.webp")}
                                alt="Chat-Icon"
                              />
                            </div>
                            <div className="dis_box_re_wrap">
                              <div className="dis_re_msg_box">
                                <span>
                                  Lorem ipsum dolor sit, amet consectetur
                                  adipisicing elit. Modi, odio natus? Beatae,
                                  hic magnam est quaerat facilis quam doloribus
                                  deleniti!
                                </span>
                              </div>
                              <span>10:15 AM</span>
                            </div>
                          </div> */}
                        </div>
                        <div className="p2p_dis_chat_btn_wrap">
                          <div className="p2p_dis_slct_img_wrap">
                            {!selectedImage ? (
                              <label
                                htmlFor="image_upload"
                                className="p2p_dis_slct_img"
                              >
                                <AddPhotoAlternateIcon />
                                <input
                                  type="file"
                                  id="image_upload"
                                  className="img_upld_icon"
                                  accept="image/*"
                                  ref={fileInputRef}
                                  // onChange={handleImageChange}
                                   onChange={(e) =>
                handleImageChange("file", e.target.files[0])
              }
                                  style={{ display: "none" }}
                                />
                              </label>
                            ) : (
                              <div className="preview_img_wrap">
                                <img
                                  src={selectedImage}
                                  alt="preview"
                                  className="preview_img_icon"
                                />
                                <span
                                  className="remove_img_btn"
                                  onClick={handleRemoveImage}
                                >
                                  <CloseIcon fontSize="small" />
                                </span>
                              </div>
                            )}
                          </div>

                          <span className="p2p_dis_chat_input">
                               <textarea
                            type="text"
                            placeholder="Start chat here"
                            name="message"
                            value={
                              formValue.message != "" ? formValue.message : ""
                            }
                            maxLength="250"
                            onChange={handleChange}
                            className="start-input"
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault(); // Prevent the default action (new line)
                                submitChat();
                              }
                            }}
                          />
                            {/* <input type="text" placeholder="Your Message" /> */}
                          </span>

                          <span className="p2p_dis_send_icon">
                              {chatloading == false ? (
                                <>
                                
                                                         <SendIcon  onClick={submitChat} />
</>
                          ) : (
                            <div className="start-icon">
                              <i class="fa-solid fa-spinner fa-spin p2p_chat_send"></i>
                            </div>
                          )}
                          </span>
                        </div>
                        </>
}

                   </div>
                </div>
              </div>
            </div>

            {/* new modal 1 => surya */}
             <div
              class="modal fade"
              id="raise_dispute_buy"
              tabindex="-1"
              aria-labelledby="raise_dispute_buyLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-header lvl-one-header">
                    <h1 class="modal-title fs-5" id="raise_dispute_buyLabel">
                      Reason for dispute 
                    </h1>
                    <button
                      type="button"
                      class="btn-close btn-close-custom"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body personal_verify_body rs_disp_bdy">
                    <h4 className="rs_mdone_title">Raise Help</h4>
                    <h5 className="rs_mdone_subtitle">
                      Experiencing Problems?
                    </h5>
                    <div>
                      <div className="dropdown rs_disp_dropdown">
                        <button
                          className="dropdown-toggle rs_disp_dropdown_toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {selectedReason}
                        </button>
                        <ul className="dropdown-menu rs_disp_dropdown_menu">
                          {reasons.map((reason, index) => (
                            <li
                              key={index}
                              onClick={() => setSelectedReason(reason)}
                            >
                              {reason}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <p className="rs_mdone_cnt mt-3">
                      You can try to resolve the issue by following these steps:
                    </p>
                    <ul className="rs_mdone_lists">
                      <li>Make sure your account information is correct.</li>
                      <li>
                        Check the buyer's payment proof or chat with them for
                        clarification
                      </li>
                      <li>
                        Some payment methods may take 1-3 days to complete.
                      </li>
                    </ul>
                    <p className="rs_mdone_cnt mt-4 mb-2">
                      *If the issue remains, you can initiate an appeal.
                    </p>

                    <button
                      className="modal_continue_btn mt-4 "
                       data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy2"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div> 

            {/* new modal 2 => surya */}
             <div
              class="modal fade"
              id="raise_dispute_buy2"
              tabindex="-1"
              aria-labelledby="raise_dispute_buyLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-header lvl-one-header">
                    <h1 class="modal-title fs-5" id="raise_dispute_buyLabel">
                      Reason for dispute 
                    </h1>
                    <button
                      type="button"
                      class="btn-close btn-close-custom"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body personal_verify_body rs_disp_bdy">
                    <h4 className="rs_mdone_title">Raise Help</h4>
                    <h5 className="rs_mdone_subtitle">
                      Experiencing Problems?
                    </h5>
                    <div>
                      <div className="dropdown rs_disp_dropdown">
                        <button
                          className="dropdown-toggle rs_disp_dropdown_toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {selectedReason}
                        </button>
                        <ul className="dropdown-menu rs_disp_dropdown_menu">
                          {reasons.map((reason, index) => (
                            <li
                              key={index}
                              onClick={() => setSelectedReason(reason)}
                            >
                              {reason}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <h5 className="rs_mdone_subtitle mt-3">Query</h5>
                    <input
                      type="text"
                      placeholder="Enter your query"
                      className="rs_mdtwo_input"
                      name="query"
                      maxLength={40}
                      value={disputequeryref.current}
                      onChange={dispute_handleChange}
                    />

                    <h5 className="rs_mdone_subtitle mt-3">Attachment</h5>

                    <div className="upload-container ">
                      {raiseloaderref.current == false ? (
                        raiseValid == 0 ? (
                          <div className="inner_frst_display2">
                            <i class="fa-solid fa-cloud-arrow-up font_soze_12"></i>
                            <p>Upload front of your document</p>
                            <p>Supported Type : .png, .webp, and .jpeg. </p>
                            <p> Max file size : 1 MB </p>
                          </div>
                        ) : (
                          <img
                            src={disputefileref.current}
                            className="up_im_past"
                            alt="Dispute proof"
                          />
                        )
                      ) : (
                        <div className="inner_frst_display">
                          <i class="fa-solid fa-spinner fa-spin"></i>
                        </div>
                      )}

                      <input
                        type="file"
                        name="file"
                        onChange={(e) =>
                          disputeUpload("file", e.target.files[0])
                        }
                        className="image_upload_kyc"
                      />
                      {raisenameref.current != "" ? (
                        <p className="pay-name text-center mt-4">
                          {raisenameref.current}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    {disputequeryref.current !="" && disputefileref.current !="" ?
                 orderTyperef.current == "Buy" ? (
                    <button className="modal_continue_btn mt-5"
                     data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3" onClick={dispute_buy}>
                      Submit Appeal
                    </button>):(
                         <button className="modal_continue_btn mt-5"
                     data-bs-toggle="modal"
                                  data-bs-target="#raise_dispute_buy3" onClick={dispute_sell}>
                      Submit Appeal
                    </button>
                    ):""}
                  </div>
                </div>
              </div>
            </div>

            {/* new modal 3 => surya */}
            {/* {model3ref.current ==true ? */}
            <div
              class="modal fade"
              id="raise_dispute_buy3"
              tabindex="-1"
              aria-labelledby="raise_dispute_buyLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-header lvl-one-header">
                    <h1 class="modal-title fs-5" id="raise_dispute_buyLabel">
                      Reason for dispute {disputequeryref.current}
                    </h1>
                    <button
                      type="button"
                      class="btn-close btn-close-custom"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body personal_verify_body rs_disp_bdy">
                    <h4 className="rs_mdone_title">Raise Help</h4>
                    <h3 className="rs_mdthree_title">
                      Appeal submitted. Awaiting response from other party
                    </h3>
                    <p className="rs_mdone_cnt mb-2">
                      The other party must respond within:{" "}
                      <span className="rs_disp_span">{timeLeft.minutes}m {timeLeft.seconds}s</span>
                    </p>
                    <ul className="rs_mdone_lists rs_mdthree_lists">
                      <li>If the both parties agree, click Cancel Appeal.</li>
                      <li>If no response in 20 minutes, arbitration starts.</li>
                      <li>You can upload more evidence anytime.</li>
                    </ul>
                    {timeLeft.minutes != "0"  &&timeLeft.seconds != "0"  ?  <button className="modal_continue_btn mt-4" onClick={()=>resolve(2)}>
                      Cancel Appeal
                    </button>:
                    <>
                     <button className="modal_continue_btn mt-4" onClick={()=>resolve(2)}>
                     Issue Resolved
                    </button> <button className="modal_continue_btn mt-4" onClick={()=>resolve(3)} >
                                        Issue Not Resolved
                    </button></>}
                   
                  </div>
                </div>
              </div>
            </div>
           
              

            {/* old modal => jothi  */}
            {/* <div
              class="modal fade"
              id="raise_dispute_buy"
              tabindex="-1"
              aria-labelledby="raise_dispute_buyLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-header lvl-one-header">
                    <h1 class="modal-title fs-5" id="raise_dispute_buyLabel">
                      Reason for dispute
                    </h1>
                    <button
                      type="button"
                      class="btn-close btn-close-custom"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body personal_verify_body lvl-one-body">
                    <div className="mar-top-12">
                      <div className="first_name">
                        <h4 className="select_id_text">Query</h4>
                        <input
                          type="text"
                          placeholder="Enter your query"
                          className="w-100"
                          name="query"
                          maxLength={40}
                          value={disputequeryref.current}
                          onChange={dispute_handleChange}
                        />
                        <p className="qurerytag">
                          {errortext ? errortext : ""}
                        </p>
                      </div>

                      <div className="first_name my-4">
                        <h4 className="select_id_text">Attachment</h4>
                      </div>

                      <div className="upload-container">
                        {raiseloaderref.current == false ? (
                          raiseValid == 0 ? (
                            <div className="inner_frst_display2">
                              <i class="fa-solid fa-cloud-arrow-up font_soze_12"></i>
                              <p>Upload front of your document</p>
                              <p>Supported Type : .png, .webp, and .jpeg. </p>
                              <p> Max file size : 1 MB </p>
                              {/* <p> Accepted
                  formats: .png, .webp, and .jpeg. The image size must
                  be under 1 MB.</p> */}
                            {/* </div>
                          ) : (
                            <img
                              src={disputefileref.current}
                              className="up_im_past"
                              alt="Dispute proof"
                            />
                          )
                        ) : (
                          <div className="inner_frst_display">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                          </div>
                        )}

                        <input
                          type="file"
                          name="file"
                          onChange={(e) =>
                            disputeUpload("file", e.target.files[0])
                          }
                          className="image_upload_kyc"
                        />
                        {raisenameref.current != "" ? (
                          <p className="pay-name text-center mt-4">
                            {raisenameref.current}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class=" bor-top-next">
                        <button
                          className="modal_continue_btn mt-4 "
                          // data-bs-dismiss="modal"
                          // aria-label="Close"
                          // onClick={thirdSubmit}
                          onClick={dispute_buy}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */} 
{/* 
            <div
              class="modal fade"
              id="raise_dispute_sell"
              tabindex="-1"
              aria-labelledby="raise_dispute_sellLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-header lvl-one-header">
                    <h1 class="modal-title fs-5" id="raise_dispute_sellLabel">
                      Reason for dispute
                    </h1>
                    <button
                      type="button"
                      class="btn-close btn-close-custom"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="modal-body personal_verify_body lvl-one-body">
                    <div className="mar-top-12">
                      <div className="first_name">
                        <h4 className="select_id_text">Query</h4>
                        <input
                          type="text"
                          placeholder="Enter your query"
                          className="w-100"
                          name="query"
                          maxLength={40}
                          value={disputequeryref.current}
                          onChange={dispute_handleChange}
                        />
                        <p className="qurerytag">
                          {errortext ? errortext : ""}
                        </p>
                      </div>

                      <div className="first_name my-4">
                        <h4 className="select_id_text">Attachment</h4>
                      </div>

                      <div className="upload-container">
                        {raiseloaderref.current == false ? (
                          raiseValid == 0 ? (
                            <div className="inner_frst_display2 gap">
                              <i class="fa-solid fa-cloud-arrow-up font_soze_12"></i>
                              <p>Upload front of your document</p>
                              <p>Supported Type : .png, .webp, and .jpeg. </p>
                              <p> Max file size : 1 MB </p>
                            </div>
                          ) : (
                            <img
                              src={disputefileref.current}
                              className="up_im_past"
                              alt="Dispute proof"
                            />
                          )
                        ) : (
                          <div className="inner_frst_display">
                            <i class="fa-solid fa-spinner fa-spin"></i>
                          </div>
                        )}

                        <input
                          type="file"
                          name="file"
                          onChange={(e) =>
                            disputeUpload("file", e.target.files[0])
                          }
                          className="image_upload_kyc"
                        />
                        {raisenameref.current != "" ? (
                          <p className="pay-name text-center mt-4">
                            {raisenameref.current}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div class=" bor-top-next">
                        <button
                          // className="modal_continue_btn mt-4"
                          // data-bs-dismiss="modal"
                          // aria-label="Close"
                          onClick={dispute_sell}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        )}
      </div>
    </>
  );
};

export default Payment;
